import axios from "axios";

axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["Accept"] = "application/json";

let token;
let auth;

const init = ({ token: _token, auth: _auth }) => {
  token = _token;
  auth = _auth;
};

// Assign stored Bearer token to Auth Header for all Requests
const setAuthorizationHeader = async (req) => {
  try {
    if (![auth.endpoints.token(), auth.endpoints.revoke()].includes(req.url)) {
      req.headers["Authorization"] = `Bearer ${token.get()}`;
    }
  } catch (err) {
    /* ignore uninitialized error */
  }

  return req;
};

axios.interceptors.request.use((req) => {
  return setAuthorizationHeader(req);
}, null);

axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    const isExpectedError =
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500;

    if (!isExpectedError) {
      return Promise.reject({
        message:
          "Unable to communicate with the server. Please try again later.",
      });
    }

    const { response } = error;
    const { data } = response;
    if (data) return Promise.reject(data);

    return Promise.reject(error);
  }
);

export default {
  init,
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
